import { ThreeCircles } from "react-loader-spinner";
import { ILoader } from "./LoaderInterface";

export const Loader = ({ height, width, styles }: ILoader) => {
  return (
    <div className={`container-standard h-full w-full ${styles}`}>
      <ThreeCircles
        height={height}
        width={width}
        visible={true}
        ariaLabel="three-circles-rotating"
        outerCircleColor="#001b48"
        innerCircleColor="#001b48"
        middleCircleColor="#001b48"
      />
    </div>
  );
};
